import { authHeader } from '../_helpers'
import httpClient from '../utils/http'
import moment from 'moment'
import { normalize, schema } from 'normalizr'
import _ from 'lodash'
import Chance from 'chance'
import { handleResponseAsync } from '../utils/HelperUtils'

import { viewConstants } from './../_constants/view.constants'
import { eventSchema } from './../entities/schema'

const chance = new Chance()

export const etimeService = {
    getAllETime,
    fetchETime,
    updateEvent,
    addEvent,
    removeEventById,
}

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            o.id = o.ID
            data.note = data.Note
            o.start = moment(o.StartDate).toDate()
            o.end = moment(o.EndDate).toDate()
            o.EmployeeID = o.EmployeeID
            o.ActionType = o.ActionType
            o.draggable = o.Status !== 'approved' ? true : false
            data.break = data.Break
            delete o._id
            delete o.StartDate
            delete o.EndDate
            delete data.Note
            viewModel.push(o)
        })
    }

    const eventListSchema = [eventSchema]
    const normalizedData = normalize(viewModel, eventListSchema)
    return normalizedData.entities
}

function convertViewModel(data) {
    if (!_.isEmpty(data)) {
        data.id = data.ID
        data.note = data.Note
        data.start = moment(data.StartDate).toDate()
        data.end = moment(data.EndDate).toDate()
        data.draggable = data.Status !== 'approved' ? true : false
        data.break = data.Break
        delete data._id
        delete data.StartDate
        delete data.EndDate
        delete data.Note
    }

    const normalizedData = normalize(data, eventSchema)
    return normalizedData.entities
}

function convertById(data) {
    return data.ID
}

function castToModel(data) {
    const vm = {}
    // const _id = chance.guid();
    vm.ID = data.id || chance.guid()
    vm.Title = data.Title || data.title
    vm.StartDate = data.StartDate || data.start
    vm.EndDate = data.EndDate || data.end
    vm.ActionType = data.ActionType
    vm.ActionHours = data.ActionHours || data.duration
    vm.Note = data.note || ''
    vm.Break = _.toNumber(data.break) || 0.0
    vm.Status = 'edit'
    vm.EmployeeID = data.EmployeeID
    vm.CompanyID = data.CompanyID
    // vm.Status = data.note || '';
    // vm.Note = data.note || '';
    return vm
}

function castToModelNew(data) {
    const vm = {}
    // const _id = chance.guid();
    vm.ID = data.id || chance.guid()
    vm.Title = data.Title || data.title
    vm.StartDate = data.StartDate || data.start
    vm.EndDate = data.EndDate || data.end
    vm.ActionType = data.ActionType
    vm.ActionHours = data.ActionHours || data.duration
    vm.Note = data.note || ''
    vm.Break = _.toNumber(data.break) || 0.0
    vm.Status = 'edit'
    vm.EmployeeID = data.EmployeeID
    vm.CompanyID = data.CompanyID
    // vm.Status = data.note || '';
    // vm.Note = data.note || '';
    return vm
}

function getAllETime() {
    const url = '/api/etime'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function fetchETime(options) {
    const url = '/api/etime'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = options || defaultQueryCond

    // const config = {
    //     url: _url,
    //     headers: {
    //         'content-type': 'application/json',
    //     },
    //     method: 'post',
    //     data: queryCond,
    // }

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateEvent(evt) {
    const url = '/api/etime'
    const payload = castToModel(evt)

    return httpClient
        .put(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function addEvent(evt) {
    const url = '/api/etime'
    const payload = castToModelNew(evt)

    return httpClient
        .post(url, payload)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeEventById(evtId) {
    const url = `/api/etime/${evtId}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}
